import CookieHelper from '@/helpers/CookieHelper';
import StoreUser from '@/models/StoreUser';
import { getPortalStore } from '@/stores/portal';
import ApiHelper from './ApiHelper';
import * as ApiIF from '@/models/ApiIF';
import DbEnum from '@/enums/DbEnum';
import AppEnum from '@/enums/AppEnum';

export default class AuthHelper {
  /**
   * ログインを行う。
   * @param {string} username
   * @param {string} password
   * @param {boolean} reAuthFlag true:再認証、false:通常認証 クラス紐づけ時はyomokka!ログインフラグは更新しない
   */
  public static async login(username: string, password: string, reAuthFlag = false) {
    const res = await ApiHelper.login({
      username,
      password,
    });

    CookieHelper.setSession(res.user.sessionId);
    CookieHelper.setViewerUsageTimeSeconds(0);
    CookieHelper.setBreakTimeMinutes(60);
    if (!reAuthFlag) {
      CookieHelper.setYmLoginFlag(false);
    }
    const store = getPortalStore();
    store.setSessionId(res.user.sessionId);

    const userInfo = await ApiHelper.getUser({});
    store.setUser(StoreUser.fromGetUserResponse(userInfo));
    if (userInfo.user.themeSettingId) {
      store.setBackgroundTheme(userInfo.user.themeSettingId);
    }
  }

  public static logout() {
    ApiHelper.logout({});
    CookieHelper.setSession(null);
    const store = getPortalStore();
    store.setSessionId(null);
    store.setUser(null);
  }

  public static async ipCheck(): Promise<ApiIF.IsAllowIpResponse> {
    const res = await ApiHelper.isAllowIp({});
    return res;
  }

  public static async ipLogin() {
    const res = await ApiHelper.ipLogin({});

    CookieHelper.setSession(res.user.sessionId);
    CookieHelper.setYmLoginFlag(false);
    CookieHelper.setViewerUsageTimeSeconds(0);
    CookieHelper.setBreakTimeMinutes(60);
    const store = getPortalStore();
    store.setSessionId(res.user.sessionId);

    const userInfo = await ApiHelper.getUser({});
    store.setUser(StoreUser.fromGetUserResponse(userInfo));
  }

  public static isWhitelist() {
    return getPortalStore().user?.constraintOption === DbEnum.constraintOption.whitelist.value;
  }

  /**
   * SSO認証ログイン
   * @param {number} idpType
   * @param {string} code
   */
  public static async ssoLogin(idpType: number, code: string) {
    let res: ApiIF.MicrosoftSsoLoginResponse | ApiIF.GoogleSsoLoginResponse;
    if (idpType === AppEnum.idpType.microsoft.value) {
      res = await ApiHelper.microsoftSsoLogin({ code });
    } else {
      res = await ApiHelper.googleSsoLogin({ code });
    }

    CookieHelper.setSession(res.user.sessionId);
    CookieHelper.setYmLoginFlag(false);
    CookieHelper.setViewerUsageTimeSeconds(0);
    CookieHelper.setBreakTimeMinutes(60);

    const store = getPortalStore();
    store.setSessionId(res.user.sessionId);

    const userInfo = await ApiHelper.getUser({});
    store.setUser(StoreUser.fromGetUserResponse(userInfo));
    if (userInfo.user.themeSettingId) {
      store.setBackgroundTheme(userInfo.user.themeSettingId);
    }
  }
}
